class CartSummary extends HTMLElement {
  constructor() {
    super();
    this.checkoutButton = this.querySelector('#checkoutButton');
    this.checkoutCaption = this.querySelector('#checkoutCaption');
    this.terms = this.querySelector('#terms');
    this.termsMarker = this.querySelector("#termsMarker");
    this.soldoutCaption = this.querySelector("#soldoutCaption");
    this.soldoutBlocked = document.getElementsByClassName('item-sold-out');

    this.setupEventListeners();
    this.checkIfDisabled();
  }

  setupEventListeners() {
    this.terms.addEventListener('change', this.checkIfDisabled.bind(this));

    document.addEventListener('quantityUpdated', () => {
      this.checkIfDisabled();
    });
  }

  hide(elt) {
    elt.classList.add('hidden');
  }

  unhide(elt) {
    elt.classList.remove('hidden');
  }

  checkIfDisabled() {
    const conditionsArray = [
      this.terms.checked,
      this.soldoutBlocked.length == 0
    ];
    if (conditionsArray.includes(false)) {
      this.checkoutButton.setAttribute('disabled', 'disabled');
      this.checkoutCaption.classList.contains("hidden") && this.unhide(this.checkoutCaption);
      this.terms.checked ? this.hide(this.termsMarker) : this.unhide(this.termsMarker);
      this.soldoutBlocked.length > 0 ? this.unhide(this.soldoutCaption) : this.hide(this.soldoutCaption);
    } else {
      this.checkoutButton.removeAttribute('disabled');
      this.hide(this.checkoutCaption);
      this.hide(this.termsMarker);
      this.hide(this.soldoutCaption);
    }
  }
}

customElements.define('cart-summary', CartSummary);
